/*
import Navigation from '@/components/navigation/Navigation'
import UserWatches from '@/components/user/UserWatches'
import UserWatchesPatients from '@/components/user/watches/UserWatchesPatients'
import UserWatchesDevices from '@/components/user/watches/UserWatchesDevices'

export default [
	{
		path: '/users/:user_uid/watches',
		name: 'WatchList',
		meta: {
			requiredAuth: true
		},
		redirect: {
			name: 'UserWatchesPatients'
		},
		components: {
			default: UserWatches,
			menu: Navigation
		},
		props: {
			default: true,
			menu: true
		},
		children: [
			{
				path: 'patients',
				name: 'UserWatchesPatients',
				component: UserWatchesPatients,
				props: true
			},
			{
				path: 'devices',
				name: 'UserWatchesDevices',
				component: UserWatchesDevices,
				props: true
			}
		]
	}
]
*/

import AppShell from '@/modules/shell/AppShell'
import Navigation from '@/components/navigation/Navigation'
import UserDevices from '@/components/user/UserDevices'

export default [
	{
		path: '/:user_uid/devices',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				name: 'DevicesList',
				path: '/',
				components: {
					default: UserDevices,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				},
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/devices.js